import type { ReactNode } from 'react';
import { cx } from './cx';
import s from './Badge.module.css';

export type Tone = 'neutral' | 'brand' | 'success' | 'warning' | 'danger' | 'info' | 'gold';

export function Badge({ tone = 'neutral', dot, pulse, children, className }: { tone?: Tone; dot?: boolean; pulse?: boolean; children: ReactNode; className?: string }) {
  return (
    <span className={cx(s.badge, s[tone], pulse && s.pulse, className)}>
      {dot && <span className={s.dot} aria-hidden />}
      {children}
    </span>
  );
}
